<template>
  <div class="card_wrapper" style="cursor: pointer;">
    <div class="main_icon_wrapper">
      <img src="../../assets/images/figma/new/5G_icon.svg">
    </div>
    <div class="card_nadpis">
			{{ $t('fiveGTitle') }}
    </div>
    <div class="card_text">
			{{ $t('fiveGDesc') }}
    </div>
    <div class="action_wrapper">
      <span>{{ $t('cardClose') }}</span><b-icon class="card_chevron" icon="chevron-right"></b-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pet_G_inside.vue"
}
</script>

<style scoped>
.action_wrapper {
  width: fit-content;
  place-self: end center;
}
.card_chevron {
  transform: scale(0.7);
  color: #72003B;
}
.action_wrapper span {
  font-family: "TeleNeoLocalRegular";
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #72003B;
}
.card_wrapper {
  padding-top: 134px;
  padding-bottom: 85px;
  padding-left: 38px;
  padding-right: 38px;
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  height: 100%;
  background: #EC7F6B;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.card_text {
  font-family: "TeleNeoLocalMedium";
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  font-weight: 500;
  font-size: 21px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.3px;
  color: #72003B;
}
.card_nadpis {
  font-family: "TeleNeoLocalExtraBold";
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  font-weight: 800;
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  letter-spacing: -0.3px;
  color: #ffffff;
}
.main_icon_wrapper {
  width: 105px;
  place-self: center;
}
.main_icon_wrapper img {
  width: 100%;
}
@media only screen and (max-width: 770px) {
  .main_icon_wrapper {
    width: 50px;
    place-self: center;
  }
  .card_text {
    font-family: "TeleNeoLocalMedium";
    -webkit-font-smoothing: antialiased !important;
    text-rendering: optimizeLegibility !important;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.3px;
    color: #72003B;
  }
  .card_nadpis {
    font-family: "TeleNeoLocalExtraBold";
    -webkit-font-smoothing: antialiased !important;
    text-rendering: optimizeLegibility !important;
    font-weight: 800;
    font-size: 28px;
    line-height: 28px;
    text-align: center;
    letter-spacing: -0.3px;
    color: #ffffff;
  }
  .card_wrapper {
    padding-top: 75px;
    padding-bottom: 28px;
    padding-left: 21px;
    padding-right: 21px;
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    height: 100%;
    background: #EC7F6B;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
}
@supports (-webkit-touch-callout: none) {
  .card_nadpis, .card_text, .action_wrapper span, .more_text {
    letter-spacing: -0.05rem !important;
  }
}
</style>
